import React from 'react'
import Text from './..'

const Strong = restProps => (
  <Text
    element='span'
    weight='bold'
    variant='neutralCool'
    variantCount='900'
    {...restProps}
  />
)

export default Strong
